/*!
* rete-readonly-plugin v0.4.1 
* (c) 2019 Vitaliy Stoliarov 
* Released under the MIT license.
*/
/// <reference types="rete-connection-plugin" />
function install(editor, params) {
  editor.bind('isreadonly');
  editor.bind('readonly');
  if (params.enabled !== false) params.enabled = true;
  editor.on('isreadonly', function () {
    return params.enabled;
  });
  editor.on('readonly', function (enabled) {
    params.enabled = enabled;
  });
  editor.on(['keydown', 'nodetranslate', 'nodeselect', 'connectioncreate', 'connectionremove', 'nodecreate', 'noderemove', 'connectionpick'], function () {
    return editor.silent || params.enabled !== true;
  });
}

var index = {
  name: 'readonly',
  install: install
};

export default index;
//# sourceMappingURL=readonly-plugin.esm.js.map
